const selector = '[data-js-video2]';
const videoFrame2 = function (el, app) {

    const $el = $(el);
    const $poster = $el.find('[data-js-video2-poster]');
    const $iframe = $el.find('[data-js-video2-iframe]');
    const $videoNative = $el.find('[data-js-video2-native]');
    const $play = $el.find('[data-js-video2-play]');
    const $allyOpen = $el.find('[data-js-video2-ally-open]');
    const $allyClose = $el.find('[data-js-video2-ally-close]');
    const autoplay = $el.attr('data-js-video2-autoplay') === 'true';

    const modes = {
        iframe: 'Iframe',
        native: 'Native'
    }

    const mode = $iframe.length ? modes.iframe : modes.native;

    let status = false;

    const init = function () {
        registerEvents();

        if (mode === modes.iframe) {
            $iframe.attr('aria-hidden', true);
        }
        else if (mode === modes.native) {
            $videoNative.attr('aria-hidden', true);
            const vn = $videoNative[0];
            vn.onerror = function () {
                console.log("Video error " + vn[0].onerror.code + "; details: " + vn[0].onerror.message);
            };
        }

        if (autoplay) {
            play({ mute: true });
        }
    };

    const registerEvents = function () {
        $poster.on('click', playStop);
        $play.on('click', playStop);
    };

    const playStop = function (ev) {
        ev.preventDefault();
        if (!status) {
            play({ mute: false });
        } else {
            stop();
        }
    };

    const play = function ({ mute }) {

        $poster.addClass('Ge-Video2-Poster--active').attr('tabindex', '-1');
        $el.addClass('Ge-Video2--active');
        let src = $poster.attr('data-js-video2-src');

        if (mode === modes.iframe) {

            $iframe.attr('aria-hidden', false);
            $iframe.addClass('Ge-Video2-Iframe--active');
            if (mute) {
                src += "&mute=1";
            }
            $iframe.attr('src', src);
        }
        else if (mode === modes.native) {
            $videoNative.attr('aria-hidden', false);
            $videoNative.prop('autoplay', true);
            if (mute) {
                $videoNative.prop('muted', true);
            }
            else {
                $videoNative.removeAttr("muted");
            }
            $videoNative.addClass('Ge-Video2-Native--active');
            const $videoNativeSrc = $videoNative.find('[data-js-video2-native-src]');
            $($videoNativeSrc[0]).attr('src', src);
            // add the classes that control the transition
        }

        // add the classes that control the transition
        $play.addClass('Ge-Video2-Play--play-stop');
        // set transition going
        playToStop();
        status = true;

        $play.removeClass('Ge-Video2-Play--play-stop').attr('tabindex', '0');
        $allyOpen.hide();
        $allyClose.show();
    };

    const playToStop = function () {
        $play.addClass('Ge-Video2-Play--active');
        $allyOpen.show();
        $allyClose.hide();
        if (mode === modes.native) {
            $videoNative[0].load();
        }
    };

    const stop = function () {

        $el.removeClass('Ge-Video2--active');
        $poster.removeClass('Ge-Video2-Poster--active').attr('tabindex', '0');

        if (mode === modes.iframe) {
            $iframe.attr('aria-hidden', true);
            $iframe.removeClass('Ge-Video2-Iframe--active');
        }
        else if (mode === modes.native) {
            $videoNative.attr('aria-hidden', true);
            $videoNative.removeClass('Ge-Video2-Native--active');
        }
        $play
            .addClass('Ge-Video2-Play--play-stop')
            .removeClass('Ge-Video2-Play--active')
            .attr('style', '')
            .attr('tabindex', '-1');

        if (mode === modes.iframe) {
            $iframe[0].src = '';
        }
        else if (mode === modes.native) {
            const $videoNativeSrc = $videoNative.find('[data-js-video2-native-src]');
            if ($videoNativeSrc.length) {
                // We must call .pause() here since the audio html5 video bug will kick in in .stop()
                $videoNative[0].pause();
            }
        }
        status = false;
        // remove the transition classes once done
        $play.removeClass('Ge-Video2-Play--play-stop');
    };

    return {
        init: init()
    };
};

videoFrame2.selector = selector;

export default videoFrame2;
